<template>
    <div class="page">
        <div class="page_content">
            <div class="top" data-aos="fade-down" data-aos-duration="500">
                <div class="top_logo">
                    <img src="../assets/images/workwx_fws.png" alt="">
                </div>
                <div class="top_title_box" data-aos="fade-down" data-aos-duration="500">
                    <div class="top_title">{{text.title[lang]}}</div>
                    <img class="bg_crm" src="../assets/images/pic_crm.png" alt="">
                </div>
                <div class="top_content" data-aos="fade-down" data-aos-duration="500">{{text.subtitle[lang]}}</div>
                <a class="btn_yuyue" v-if="lang === 0" href="mailto:info@deansel.com" data-aos="fade-down" data-aos-duration="500"><img class="btn_yuyue_img" src="../assets/images/btn_yuyue.png" alt=""></a>
                <a class="btn_yuyue" v-else href="mailto:info@deansel.com" data-aos="fade-down" data-aos-duration="500"><img class="btn_yuyue_img" src="../assets/images/btn_contact.png" alt=""></a>
            </div>
            <div class="banner_box">
                <div class="banner_title" data-aos="fade-down" data-aos-duration="500">{{text.bannerTitle[lang]}}</div>
                <swiper class="banner_swiper" ref="mySwiper" :options="swiperOptions" data-aos="fade-down" data-aos-duration="500" data-aos-delay="300">
                    <swiper-slide class="banner_swiper_slide" v-for="(item, index) in text.bannerImgs" :key="index">
                        <img class="banner_img" :src="item" alt="">
                    </swiper-slide>
                </swiper>
            </div>
            <div class="core_box">
                <div class="banner_title" data-aos="fade-down" data-aos-duration="500">{{text.coreTitle[lang]}}</div>
                <div class="core_content">
                    <img class="core_img" src="../assets/images/liudahexin.png" alt="">
                    <div class="core_item_box">
                        <div class="core_item" v-for="(item, index) in text.coreContent.slice(0, 2)" :key="index" data-aos="fade-down" data-aos-duration="500">
                            <div class="core_item_title">{{item.title[lang]}}</div>
                            <div class="core_item_text">{{item.content[lang]}}</div>
                        </div>
                    </div>
                    <div class="core_item_box">
                        <div class="core_item" v-for="(item, index) in text.coreContent.slice(2, 4)" :key="index" data-aos="fade-down" data-aos-duration="500">
                            <div class="core_item_title">{{item.title[lang]}}</div>
                            <div class="core_item_text">{{item.content[lang]}}</div>
                        </div>
                    </div>
                    <div class="core_item_box">
                        <div class="core_item" v-for="(item, index) in text.coreContent.slice(4, 6)" :key="index" data-aos="fade-down" data-aos-duration="500">
                            <div class="core_item_title">{{item.title[lang]}}</div>
                            <div class="core_item_text">{{item.content[lang]}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="func_box">
                <div class="func_title" data-aos="fade-down" data-aos-duration="500">{{text.funcTitle[lang]}}</div>
                <div class="core_content">
                    <div class="func_item" v-for="(item, index) in text.funcContent" :key="index">
                        <img class="func_item_img" :src="item.img" alt="" data-aos="fade-down" data-aos-duration="500">
                        <div class="func_item_text" data-aos="fade-down" data-aos-duration="600">
                            <div class="func_item_title">{{item.title[lang]}}</div>
                            <div class="func_item_content">{{item.content[lang]}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Foot/>
        <Nav navstyle="dark"></Nav>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {wxShare} from '@/js/api.js'
import {productText} from '@/js/text.js'
export default {
    components: {
        Nav,
        Foot,
        Swiper,
        SwiperSlide
    }, 
    data () {
        return {
            text: productText,
            swiperOptions: {
                speed: 2000,//切换速度
                loop: true,
                slidesPerView: 6,
                autoplay: {
                    delay: 1000,
                    stopOnLastSlide: false
                },
            }
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        },
        swiper () {
            return this.$refs.mySwiper.$swiper
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '产品页'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    }
}
</script>

<style scoped>
.top {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(#AFCFED, #E6F3FF 75%, #ffffff);
    position: relative;
    text-align: left;
    margin-bottom: 10%;
    padding-top: 20%; 
    box-sizing: border-box;
    line-height: 1.5;
}
.top_logo {
    position: absolute;
    height: 24px;
    padding-left: 20px;
    top: 22px;
    left: 170px;
    border-left: rgba(0, 0, 0, 0.2) solid 1px;
}
.top_logo img {
    height: 100%;
}
.top_title_box {
    width: 80%;
    min-height: 22rem;
    margin: 0 10%;
    position: relative;
}
.top_title {
    position: absolute;
    left: 0;
    color: #3486C2;
    font-size: 3.25rem;
    z-index: 1;
    font-weight: bold;
}
.top_content {
    width: 80%;
    margin: 0 10%;
    font-size: 1.125rem;
    font-weight: 450;
}
.bg_crm {
    width: 60vw;
    max-width: 800px;
    position: absolute;
    top: -40%;
    right: -10vw;
}
.btn_yuyue {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 3%;
}
.btn_yuyue_img {
    width: 160px;
}
.banner_box {
    width: 80vw;
    margin: 0 10% 10% 10%;
    line-height: 1.5;
}
.banner_title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 5%;
    text-align: center;
}
.banner_swiper {
    width: 100%;
    height: 7vw;
}
.banner_swiper_slide {
    height: 100%;
}
.banner_img {
    height: 100%;
}
.core_box {
    width: 100%;
    padding: 5% 10vw;
    box-sizing: border-box;
    line-height: 1.5;
    background: #f2f9ff;
    margin-bottom: 10%;
}
.core_content {
    width: 100%;
    position: relative;
}
.core_item_box {
    width: 68vw;
    margin: 0 6vw;
    display: flex;
    justify-content: space-between;
    align-content: center;
}
.core_item_box:nth-child(3) {
    width: 100%;
    margin: 3vw 0;
}
.core_item {
    width: 24vw;
    text-align: left;
    line-height: 1.5;
}
.core_item_title {
    width: 100%;
    color: #21A4FF;
    font-size: 1.125rem;
    margin-bottom: 3%;
    font-weight: bold;
}
.core_item:nth-child(1) .core_item_title {
    text-align: right;
}
.core_item_text {
    width: 100%;
    font-size: 0.875rem;
    color: #666;
}
.core_img {
    width: 25vw;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.func_box {
    width: 100%;
}
.func_title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
}
.func_item {
    width: 100%;
    padding: 10%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.func_item:nth-child(2n) {
    flex-direction: row-reverse;
    background: #f2f9ff;
}
.func_item_img {
    width: 40vw;
}
.func_item_text {
    width: 34vw;
    text-align: left;
    line-height: 1.5;
}
.func_item_title {
    width: 100%;
    margin-bottom: 2vw;
    font-size: 1.125rem;
    font-weight: bold;
    color: #21A4FF;
}
.func_item_content {
    width: 100%;
    color: #666;
    font-size: 0.875rem;
}
@media screen and (max-width: 756px) {
    .top_logo {
        top: 27px;
        left: 74px;
    }
    .top_title {
        width: 100%;
        position: static;
    }
    .top_content {
        margin: 10%;
    }
    .bg_crm {
        width: 100%;
        position: static;
        display: block;
    }
    .core_item_box {
        width: 100%;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }
    .core_item_box:nth-child(3) {
        width: 100%;
        margin: 0;
    }
    .core_item {
        width: 100%;
        margin: 0 0 10% 0;
    }
    .core_item:nth-child(1) .core_item_title {
        text-align: left;
    }
    .core_img {
        width: 80%;
        margin: 5% 10%;
        position: static;
        transform: translate(0, 0);
    }
    .func_item {
        flex-direction: column;
        justify-content: flex-start;
    }
    .func_item:nth-child(2n) {
        flex-direction: column;
        justify-content: flex-start;
    }
    .func_item_img {
        width: 100%;
        margin-bottom: 5%;
    }
    .func_item_text {
        width: 100%;
    }
}
@media screen and (min-width: 1200px) {
    .bg_crm {
        left: 30%;
    }
}
</style>
